/**
 * オプション設定ページ用のスクリプト
 */
 if (is_route('option_setting.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        option_setting_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.option_setting_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['holding_id'], false);
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 会社設定表示 ----*/

    // 会社選択時
    $(document).on('change', '#option-setting-modal-company_id', function() {
        if($(this).val() != null && $(this).val().length > 0){
            updateCompanyDetailForms($(this));
        }
    });

    // 会社設定画面表示
    function updateCompanyDetailForms(elm)
    {
        let target = '#company_detail_forms';
        let action = $(target).data('action');
        _ajax.post(action, [
            {'name': 'holding_id', 'value': $('#option-setting-modal-holding_id').val()},
            {'name': 'company_id', 'value': $(elm).val()},
        ], function (response) {
            $(target).html(response);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        }, 'html');
    }
}
